import React from 'react';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

//styling
import './DatePicker.css';

const DatePickerComponent = (props) => {

    const {
        onDateSelected
    } = props;

    const onChange = (date) => {
        onDateSelected(date.toLocaleDateString("en-US"));
    }

    return (<div className="datepicker-inline">
        <strong>Date: </strong> 
        <p>&nbsp;</p>
        <DatePicker
            placeholderText="Click to select a date"
            className="datepicker"
            maxDate={new Date()}
            onChange={onChange}
        />
    </div>);
}

export default DatePickerComponent;